import React, { useEffect } from 'react'
import { Select } from './../../Form/Select'
import { urlAdd, urlAddExist, urlRemove, urlGet } from '../../../Utils/URL'

export const FilterSelectUnstyled = props => {
  useEffect(() => {
    const value = urlGet(props.label)
    const valueEl = props.options.find(element => element.value == value)
    if (value && valueEl && props.value != value) {
      props.onChange(
        {
          target: { value },
          stopPropagation: () => {},
          preventDefault: () => {},
        },
        0,
        value,
      )
    }
  }, [props.label, props.options])

  return (
    <div key={props.label + 'div'} className={props.className} id={props.id}>
      {!props.withoutLabel && props.label && <label>{props.label}</label>}
      <Select
        key={props.label}
        options={props.options}
        name={props.name}
        hasPrimaryText={!!props.hasPrimaryText}
        primaryText={props.primaryText || 'All'}
        value={props.value}
        autoWidth={!!props.autoWidth}
        {...props}
        onChange={(e, i, v) =>
          syncOnChangeWithUrl(
            props.enableMultiFilterValues,
            props.label,
            props.onChange,
            e,
            i,
            v,
          )
        }
        cypress_id={props.label.split(' ').join('-') + '-' + props.cypress_id}
      />
    </div>
  )
}

/**
 * Wrap an value onChange function with url syncing
 * @param {string} label The key to use in the url
 * @param {Function} func The original onChange function, expects the first
 * value to be the value, could be an array of values.
 * @returns {Function}
 */
const syncOnChangeWithUrl = (
  enableMultiFilterValues,
  label,
  onChange,
  e,
  i,
  selectedValue,
) => {
  if (selectedValue && (label === 'Period' || selectedValue !== 'All')) {
    enableMultiFilterValues
      ? urlAddExist(label, selectedValue)
      : urlAdd(label, selectedValue)
  } else {
    urlRemove(label)
  }
  return onChange(e, i, selectedValue)
}
